<template>
    <div class="sub-visual">
        <div class="sub-visual__wrapper">
            <h3 class="sub-visual__tit"><span>{{visual}}</span></h3>
        </div>
	</div>
</template>

<script>

export default{
    props : {
        visual : {type :String, default : ""}
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>